/**
 * Determine whether a question is required based on multiple 'required_if' rules.
 * @param field
 * @param form
 * @returns boolean
 */
export const isRequired = (field, form) => {
    if (field.required) {
        return true;
    }

    if (field.requiredIfRules && field.requiredIfRules.length) {
        return field.requiredIfRules.some(rule =>     
            Array.isArray(form[rule.field]) 
                ? form[rule.field].some(value => rule.values.includes(value)) 
                : rule.values.includes(form[rule.field])
        );
    }
    return false;
};
